export enum SearchType {
  HOME = "home",
  CLUB = 'club',
  MATCH = 'match'
}
